export const ElectroMechanical = require('./electro-mechanical.svg');
export const Fuel = require('./fuel.svg');
export const Hydraulics = require('./hydraulic.svg');
export const Pneumatics = require('./pneumatic.svg');
export const WaterAndWaste = require('./water-and-waste.svg');
export const DiamondExcellence = require('./diamond-excellence.svg');

export const FAA = require('./faa-logo.png');
export const EASA = require('./easa-logo.png');
export const CAAC = require('./caac-logo.png');